import { Badge, View } from "@/components/ui";
import type { ReactNode } from "react";
import type { Icon } from "@/components/shared/icons";
import { Row } from "@/components/ui/layout";
import { Typography } from "../typography";

export function ListHeading({
  title,
  subtitle,
  icon: IconComponent,
  action,
  label,
}: {
  title: string;
  subtitle?: string;
  icon?: Icon;
  action?: ReactNode;
  label?: "Required" | "Optional";
}) {
  return (
    <View className="flex flex-row justify-between">
      <Row gap="md" items="center">
        {!!IconComponent && (
          <IconComponent size={24} weight="fill" className="color-primary" />
        )}
        <View>
          <View className="flex flex-row items-center gap-2">
            <Typography variant="label-md">{title}</Typography>
            {label && (
              <Badge variant={label === "Required" ? "success" : "neutral"}>
                {label}
              </Badge>
            )}
          </View>
          {subtitle && (
            <Typography variant="body-sm" color="secondary-text">
              {subtitle}
            </Typography>
          )}
        </View>
      </Row>
      {action}
    </View>
  );
}
